export const FETCHING_CONVERSATIONS = "FETCHING.CONVERSATIONS";
export const FETCHED_CONVERSATIONS = "FETCHED.CONVERSATIONS";
export const ERROR_FETCHING_CONVERSATIONS = "ERROR.FETCHING.CONVERSATIONS";

export const FETCHING_MESSAGES = "FETCHING.MESSAGES";
export const FETCHED_MESSAGES = "FETCHED.MESSAGES";
export const ERROR_FETCHING_MESSAGES = "ERROR.FETCHING.MESSAGES";

export const SENDING_MESSAGE = "SENDING.MESSAGE";
export const SENT_MESSAGE = "SENT.MESSAGE";
export const ERROR_SENDING_MESSAGE = "ERROR.SENDING.MESSAGE";

export const CREATING_CONVERSATION = "CREATING.CONVERSATION";
export const CREATED_CONVERSATION = "CREATED.CONVERSATION";
export const ERROR_CREATING_CONVERSATION = "ERROR.CREATING.CONVERSATION";

export const FETCHING_CONVERSATION_MEMBERS = "FETCHING.CONVERSATION.MEMBERS";
export const FETCHED_CONVERSATION_MEMBERS = "FETCHED.CONVERSATION.MEMBERS";
export const ERROR_FETCHING_CONVERSATION_MEMBERS = "ERROR.CONVERSATION.MEMBERS";
